/**
 * CRM Page Constants
 * Constantes de filtros e opções para a página de CRM.
 */

// Opções de Duração de Plano
export const DURATION_OPTIONS = [
    { value: "", label: "Todos" },
    { value: "monthly", label: "Mensal" },
    { value: "yearly", label: "Anual" },
    { value: "days", label: "Por dias" },
    { value: "classes", label: "Pacote de aulas" },
];

// Estado inicial dos filtros
export const INITIAL_FILTERS = {
    search: "",
    status: "",
    gender: "",
    membershipId: "",
    durationType: "",
    contractStartDate: "",
    contractEndDate: "",
    activityId: "",
    ageMin: "",
    ageMax: "",
    employeeId: "",         // Professor
    consultantId: "",       // Consultor (Venda)
    saleStartDate: "",
    saleEndDate: "",
};

export const INITIAL_ACTIVE_FILTERS = {
    search: true,
    status: false,
    gender: false,
    membershipId: false,
    durationType: false,
    contractDate: false,
    activityId: false,
    age: false,
    employeeId: false,
    consultantId: false,
    saleDate: false
};

// Quantidade de resultados por página
export const PAGE_SIZE = 50;
